/**
 * 管理员 全部菜单 全部权限
 * */
export const superadmin = 'superadmin';

export default {
  superadmin: superadmin
}



// WEBPACK FOOTER //
// ./src/common/jdyrole.js